import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { EVENT_TYPE } from '../../../../constants/index';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';
import { lineHeight } from '@material-ui/system';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.mixins.marginRight('5.5%'),
    maxWidth: '844px'
  },
  infoDetails: {
    padding: `${pxToRem(64)} 0`,
    color: '#000'
  },
  heading: {
    fontSize: pxToRem(32),
    lineHeight: pxToRem(40),
    color: '#000'
  },
  ticketWrapper: {
    '& .mainHeading': {
      marginBottom: pxToRem(32)
    },
    '& .innerWrap': {
      display: 'flex',
      gap: pxToRem(16),
      '& .ticketBox': {
        position: 'relative',
        '& a': {
          display: 'block',
          padding: pxToRem(24),
          textDecoration: 'none'
        },
        '&:before': {
          position: 'absolute',
          left: 0,
          bottom: 0,
          height: '3px',
          content: '""',
          width: '100%',
          backgroundColor: '#FF8707'
        },
        width: '100%',
        backgroundColor: '#FCEFDE',
        '& .priceHeading': {
          marginLeft: 0,
          color: '#000'
        },
        '& .price': {
          paddingTop: pxToRem(16),
          color: '#000'
        }
      }
    }
  }
}));

export default useStyles;
